<template>
  <view-container>
    <browse-tabs
      browse
      :model-value="BROWSE_TABS.LIBRARY"
      @toggle:filters="toggleFilterMenu"
    />

    <base-switcher
      v-if="tabs.length > 1"
      :model-value="tab"
      :options="tabs"
      class="tw-mb-6 -tw-mt-2"
      @input="(_, newTab) => updateTab(newTab)"
    />

    <keep-alive>
      <my-subscriptions v-if="tab === CONTENT_TYPE.MOD" />
      <my-followed-collections v-else-if="tab === CONTENT_TYPE.COLLECTION" />
      <my-purchases v-else-if="tab === CONTENT_TYPE.PURCHASES" />
    </keep-alive>
  </view-container>
</template>

<script>
import MyFollowedCollections from '@components/Profile/Tables/MyFollowedCollections.vue'
import MySubscriptions from '@components/Profile/Tables/MySubscriptions.vue'
import { useResourceValue, useNavSubMenu, useRoute } from '@composables'
import MyPurchases from '@components/Profile/Tables/MyPurchases.vue'
import ViewContainer from '@components/View/ViewContainer.vue'
import BrowseTabs from '@components/Navigation/BrowseTabs.vue'
import { BROWSE_TABS, ITEM_TYPES } from '@config/options.js'
import { toggleFilterMenu } from '@composables/useFilter.js'
import { Settings } from '@config/game.js'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import {
  collectionFollowingStore,
  subscriptionStore,
  purchasesStore,
} from '@stores'

const CONTENT_TYPE = {
  MOD: ITEM_TYPES.MOD,
  COLLECTION: ITEM_TYPES.COLLECTION,
  PURCHASES: 'purchases',
}

export default {
  components: {
    MyFollowedCollections,
    MySubscriptions,
    ViewContainer,
    MyPurchases,
    BrowseTabs,
  },
  setup() {
    const { followedCollections } = collectionFollowingStore()
    const { subscriptions } = subscriptionStore()
    const { purchases } = purchasesStore()

    const { ugcName } = useResourceValue()
    const { t } = useI18n()

    const { routeQuery, replace } = useRoute()

    const ugcNameText = computed(() => {
      let _ugcNameText = ugcName(null, false, false).value

      if (['mods', 'levels'].includes(_ugcNameText.toLowerCase())) {
        _ugcNameText = t(_ugcNameText.split('s')[0].toLowerCase(), 2)
      }

      return _ugcNameText
    })

    const tabs = computed(() => {
      const tabs = [
        {
          value: CONTENT_TYPE.MOD,
          text: t('subscribed_ugc', { ugc: ugcNameText.value }),
          count: subscriptions.value.length,
        },
      ]

      if (Settings.value.showMarketplace) {
        tabs.push({
          value: CONTENT_TYPE.PURCHASES,
          text: t('marketplace.purchases', { ugc: ugcNameText.value }),
          count: purchases.value.length,
        })
      }

      if (Settings.value.showCollections) {
        tabs.push({
          value: CONTENT_TYPE.COLLECTION,
          text: t('followed_collections'),
          count: followedCollections.value.length,
        })
      }

      return tabs
    })

    const { tab, updateTab } = useNavSubMenu(
      'library',
      tabs.value,
      onTabUpdated,
      routeQuery.value.tab ?? ITEM_TYPES.MOD
    )

    function onTabUpdated(tab) {
      replace({
        query: { tab },
      })
    }

    return {
      toggleFilterMenu,
      CONTENT_TYPE,
      BROWSE_TABS,
      updateTab,
      tabs,
      tab,
    }
  },
}
</script>
